var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    d: "M55.785,34.99a.9992.9992,0,0,1,.1055,1.041l-3.8946,8.0626a1.0021,1.0021,0,0,1-.706.5468L40.492,46.7783a1.007,1.007,0,0,1-.7939-.1806L16.2137,29.02a1.0007,1.0007,0,0,1-.1758-1.4316l2.4385-2.9971a.9981.9981,0,0,1,.3252-.2627l18.3057-9.2217a1.0147,1.0147,0,0,1,.6572-.0849l3.8193.8066a.9974.9974,0,0,1,.6367.4424l2.6731,4.144,1.6213,2.4905Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f3f3f",
    points: "26.692 56 46.788 56 40.317 45.819 16.943 28.219 15.814 33.046 26.692 56"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b9b9a",
    points: "54.78 36.031 56.128 47.544 54.469 56 46.788 56 40.317 45.819 50.939 43.94 54.78 36.031"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "45.797 23.608 54.99 35.597 56.128 47.239 54.469 56 26.692 56 16 32.86 16.813 28.219 19.252 25.222 37.558 16 41.377 16.807 44.02 20.917 39.008 24.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "47.359 56 40.298 45.797 16.813 28.219"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "54.99 35.597 51.095 43.659 40.298 45.797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.874bd4972848feaee23de66fb90bd6b1.svg";
export { ForwardRef as ReactComponent };